import { getSelectors } from '@repo/core'
import { RootState } from '../../store/types'

export const editUserPreferencesIsLoadingSelector = (state: RootState) =>
  state.users.user.write.preferences.meta.fetchState === 'loading'
export const editUserPreferencesHasErrorSelector = (state: RootState) =>
  state.users.user.write.preferences.error

export const userPreferencesDataSelector = {
  ...getSelectors({
    getRootPath: (state: RootState) => state.users.user.read.preferences,
  }),
  isDoneSelector: (state: RootState) =>
    state.users.user.read.preferences.meta.fetchState === 'done',
}
